import { Platform } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { FeatureNames, ServicePointFeatures, ServicePointTenantConfigurationDto, TenantSettings } from '@deprecated/api-interfaces';
import { ThemingService } from '@ird/ng-base';
import { ServicePointFeature, TenantService } from '@ird/ng-common';
import { FileRepositoryUi } from '../repositories/file-ui.repository';
import { GtmService } from './gtm.service';

@Injectable({
  providedIn: 'root',
})
export class TenantConfigService {
  config: ServicePointTenantConfigurationDto;
  service: { features: any[] };

  constructor(
    @Inject(DOCUMENT) private _document: Document,
    private themingService: ThemingService,
    private fileRepositoryUI: FileRepositoryUi,
    private platform: Platform,
    private tenantService: TenantService,
    private gtmService: GtmService,
  ) {}

  setConfig(config: ServicePointTenantConfigurationDto) {
    this.config = config;
    this.themingService.loadTheme(config.themeDefinition);
    this.setNavigationTenantImage(this.fileRepositoryUI.getTenantImage(config.logoFileId));
    this.tenantService.setTenantSettings(config as unknown as TenantSettings);
    this.gtmService.setBusinessUnit(config.businessUnitName);
  }

  getConfig() {
    return this.config;
  }

  getThemeDefinition() {
    return this.config.themeDefinition;
  }

  getTenantId() {
    return this.config.tenantId;
  }

  getLogoFileId() {
    return this.config.logoFileId;
  }

  getAppUrl(): string {
    return this.getServicePointFeatures()[ServicePointFeatures.APP_URL];
  }

  getImprintUrl(): string {
    return this.getServicePointFeatures()[ServicePointFeatures.IMPRINT_URL];
  }

  getEloquaBrandCode(): string {
    return this.getServicePointFeatures()[ServicePointFeatures.ELOQUA_BRAND_CODE];
  }

  getBrandName(): string {
    return this.getServicePointFeatures()[ServicePointFeatures.BRAND_NAME];
  }

  getAppName(): string {
    return this.getServicePointFeatures()[ServicePointFeatures.APP_NAME];
  }

  public getServicePointFeatures(): ServicePointFeature {
    return this.config?.features.find((feature) => feature[ServicePointFeatures.NAME] === FeatureNames.SERVICE_POINT);
  }

  public setNavigationTenantImage(url: string): void {
    if (url) {
      if (this.platform.IOS) {
        this._document.body.style.setProperty('--logo-url', 'url(' + url + ')');
      } else {
        this._document.body.style.setProperty('--logo-url', 'url("' + url + '")');
      }
    } else {
      this._document.body.style.removeProperty('--logo-url');
    }
  }

  public isFeatureEnabled(feature: ServicePointFeatures): boolean {
    return this.getServicePointFeatures()[feature];
  }

  public getValueFromServicePointFeatureWithDefaultValue<T>(key: keyof ServicePointFeature, defaultValue: T): T {
    return (this.getServicePointFeatures()?.[key] ?? defaultValue) as T;
  }

  getPartsTileTitle(): string {
    const customTileEnabled = this.getServicePointFeatures()[ServicePointFeatures.SPARE_PART_CUSTOM_TILE];
    const customText = this.getServicePointFeatures()[ServicePointFeatures.SPARE_PART_CUSTOM_TILE_TEXT];

    if (customTileEnabled && customText) {
      return customText;
    }
    return 'SERVICEPOINT.HOME.BUTTONS.PARTS_AND_SERVICE';
  }
}
